import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    animationName: '$fill',
    animationDuration: '0.4s',
    animationTimingFunction: 'ease-in-out',
    animationDelay: '0.4s',
    animationFillMode: 'forwards',
    animationIterationCount: '1',
  },
  
  checkmark: {
    width: '66px',
    height: '66px',
    borderRadius: '50%',
    display: 'block',
    strokeWidth: '2.5',
    stroke: '#fff',
    strokeMiterlimit: '10',
    boxShadow: `inset 0px 0px 0px ${Colors.green}`,
    animation: '$fill 0.4s ease-in-out 0.4s forwards, $scale 0.3s ease-in-out 0.9s both',
  },
  
  checkmark_circle: {
    strokeDasharray: '166',
    strokeDashoffset: '166',
    strokeWidth: '2',
    strokeMiterlimit: '10',
    stroke: Colors.green,
    fill: 'none',
    animation: '$stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards',
  },
  
  checkmark_check: {
    transformOrigin: '50% 50%',
    strokeDasharray: '48',
    strokeDashoffset: '48',
    animation: '$stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards',
  },
  
  '@keyframes fill': {
    '0%': {
      boxShadow: `inset 0px 0px 0px 0px ${Colors.green}`,
      borderRadius: '50%',
    },
    '100%': {
      boxShadow: `inset 0px 0px 0px 60px ${Colors.green}`,
      borderRadius: '50%',
    },
  },
  
  '@keyframes stroke': {
    '100%': {
      strokeDashoffset: 0,
    },
  },
  
  '@keyframes scale': {
    '0%, 100%': {
      transform: 'none',
    },
    '50%': {
      transform: 'scale3d(1.1, 1.1, 1)',
    },
  },
}))

export default styles
